<template>
  <hr class="division_line" :class="className" />
</template>


<script>
export default {
  props: {
    className: {
      type: String,
      default: null,
    }
  }
};
</script>

<style>
</style>